import { Divider } from 'antd';
import React from 'react';

type Props = {
  summary: any;
  children: any;
  className?: string;
  divider?: boolean;
};

export default function Section({ summary, children, className, divider }: Props) {
  return (
    <div className={className}>
      <div className="flex gap-2xl">
        {summary}
        {children}
      </div>
      {divider && <Divider />}
    </div>
  );
}
